import {
  LessonExercisePlacement,
  type LessonExerciseSummaryDto
} from '../services/contentService';

export function isInlineLessonExercise(ex: LessonExerciseSummaryDto): boolean {
  return (
    ex.isInlineInLessonBody === true ||
    ex.placement === LessonExercisePlacement.InlineInContent
  );
}
